import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IAddToAgendaPayload {
    data: {
        type: string
        typeId: string
        notes: string
        timeslots: {
            startDate: string
            endDate: string
        }[]
    }
    sagaCB: any
}

export interface IAddToAgendaState {
    status: string
    data: any
    errors: any
}

const initialState: IAddToAgendaState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const addToAgenda = createSlice({
    name: 'meeting/add-to-agenda',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IAddToAgendaPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const addToAgendaActions = addToAgenda.actions
export default addToAgenda.reducer
